
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/authentication/supporting-non-plaid-traffic",
      function () {
        return require("private-next-pages/core-exchange/docs/authentication/supporting-non-plaid-traffic/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/authentication/supporting-non-plaid-traffic"])
      });
    }
  